import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '@/services/api';
import { useI18n } from '@/contexts/I18nContext';
import { ArrowLeft, Mail } from 'lucide-react';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useI18n();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await authAPI.forgotPassword({ email });
    } catch {
      // Always show success (don't reveal if email exists)
    } finally {
      setIsLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-foreground-muted hover:text-accent mb-8" data-testid="back-to-login">
          <ArrowLeft size={16} />
          {t('forgot.back')}
        </Link>

        <h2 className="text-2xl font-semibold mb-2">{t('forgot.heading')}</h2>
        <p className="text-foreground-secondary text-sm mb-6">
          {t('forgot.description')}
        </p>

        {sent ? (
          <div className="card p-6 text-center space-y-3" data-testid="reset-sent-message">
            <Mail size={32} className="mx-auto text-accent" />
            <p className="text-sm text-foreground-secondary">
              {t('forgot.sent_message')}
            </p>
            <Link to="/login" className="btn btn-primary inline-flex items-center gap-2 mt-4">
              {t('forgot.back_to_login')}
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-password-form">
            <div>
              <label className="block text-sm font-medium text-foreground-secondary mb-2">{t('forgot.email_label')}</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('forgot.email_placeholder')}
                required
                data-testid="forgot-email"
              />
            </div>
            <button type="submit" disabled={isLoading} className="w-full btn btn-primary btn-lg" data-testid="forgot-submit">
              {isLoading ? <div className="spinner w-5 h-5" /> : t('forgot.submit')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
